import { render, staticRenderFns } from "./ProjectListWidget.vue?vue&type=template&id=5ca10834"
import script from "./ProjectListWidget.vue?vue&type=script&lang=js"
export * from "./ProjectListWidget.vue?vue&type=script&lang=js"
import style0 from "./ProjectListWidget.vue?vue&type=style&index=0&id=5ca10834&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports